module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-15.9b17e5f8.png";